/**
 * Skeleton Loader for Role Permissions Table
 * Beautiful, modern loading animation
 */

import React from 'react';
import './SkeletonLoader.scss';

const SkeletonLoader = () => {
  // Generate skeleton rows
  const skeletonRoles = [1, 2, 3, 4, 5]; 
  const skeletonModules = [1, 2, 3, 4, 5];
  const permissionsPerModule = [3, 4, 3, 4];

  return (
    <div className="rp-skeleton-container">
      {/* Top Controls Skeleton */}
      <div className="rp-controls-skeleton">
        <div className="skeleton-search">
          <div className="skeleton-box skeleton-search-input"></div>
        </div>
        <div className="skeleton-button"></div>
      </div>

      {/* Table Skeleton */}
      <div className="rp-table-skeleton">
        <table className="skeleton-table">
          {/* Table Header Skeleton */}
          <thead>
            <tr>
              <th className="skeleton-th-first">
                <div className="skeleton-box skeleton-header-text"></div>
              </th>
              {skeletonRoles.map((role) => (
                <th key={role} className="skeleton-th">
                  <div className="skeleton-box skeleton-role-header"></div>
                </th>
              ))}
            </tr>
          </thead>

          {/* Table Body Skeleton */}
          <tbody>
            {skeletonModules.map((module, moduleIdx) => (
              <React.Fragment key={module}>
                {/* Module Header Row */}
                <tr className="skeleton-module-row">
                  <td className="skeleton-module-name">
                    <div className="skeleton-box skeleton-module-text"></div>
                  </td>
                  {skeletonRoles.map((role) => (
                    <td key={role} className="skeleton-module-cell">
                      <div className="skeleton-checkbox"></div>
                    </td>
                  ))}
                </tr>

                {/* Permission Rows */}
                {Array.from({ length: permissionsPerModule[moduleIdx] }).map((_, permIdx) => (
                  <tr key={`${module}-${permIdx}`} className="skeleton-permission-row">
                    <td className="skeleton-permission-name">
                      <div className="skeleton-dot"></div>
                      <div className="skeleton-box skeleton-permission-text"></div>
                    </td>
                    {skeletonRoles.map((role) => (
                      <td key={role} className="skeleton-permission-cell">
                        <div className="skeleton-checkbox"></div>
                      </td>
                    ))}
                  </tr>
                ))}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>

    </div>
  );
};

export default SkeletonLoader;

